<h1 mat-dialog-title>Delete {{data.title}}?</h1>
<mat-dialog-content>
    <p>Verwijderen van week {{data.title}}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Annuleren</button>
    <button mat-button [mat-dialog-close]="true" color="warn">Verwijderen</button>
</mat-dialog-actions>